import { render, staticRenderFns } from "./cloudPlatform.vue?vue&type=template&id=00304ebc&scoped=true&"
import script from "./cloudPlatform.vue?vue&type=script&lang=js&"
export * from "./cloudPlatform.vue?vue&type=script&lang=js&"
import style0 from "./cloudPlatform.vue?vue&type=style&index=0&id=00304ebc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00304ebc",
  null
  
)

export default component.exports